/* eslint-disable import/prefer-default-export */
export const COUPON_STATUS = {
  unConfirm: 0, // 未确认
  receive: 1, // 待领取
  use: 2, // 已领取，去使用
  achieve: 3, // 已使用
  fail: 4, // 已作废
  expired: 5, // 已过期
  wait: 6, // 待生效
  locked: 8, // 待解锁
  changeed: 9, // 已更换
  expansived: 10, // 已膨胀
  recovery: 11, // 已回收
  unavailable: 12, // 不可选
};

export const COUPON_BUTTON_MAP = {
  [COUPON_STATUS.receive]: '领取',
  [COUPON_STATUS.use]: '去使用',
  [COUPON_STATUS.achieve]: '已使用',
  [COUPON_STATUS.expired]: '已过期',
  [COUPON_STATUS.fail]: '已作废',
  [COUPON_STATUS.wait]: '待生效',
  [COUPON_STATUS.locked]: '待解锁',
  [COUPON_STATUS.changeed]: '已更换',
  [COUPON_STATUS.expansived]: '已膨胀',
  [COUPON_STATUS.recovery]: '已发放',
  [COUPON_STATUS.unavailable]: '不可选',
};

export const COUPON_PROGRESS_STATUS_MAP = {
  [COUPON_STATUS.receive]: '待领取',
  [COUPON_STATUS.use]: '待使用',
  [COUPON_STATUS.achieve]: '已使用',
  [COUPON_STATUS.expired]: '已过期',
  [COUPON_STATUS.fail]: '已作废',
  [COUPON_STATUS.wait]: '待生效',
  [COUPON_STATUS.locked]: '待解锁',
  [COUPON_STATUS.changeed]: '已更换',
  [COUPON_STATUS.expansived]: '已膨胀',
  [COUPON_STATUS.recovery]: '已发放',
  [COUPON_STATUS.unavailable]: '不可选',
};

export const COUPON_ORIGIN_STATUS_MAP = {
  [COUPON_STATUS.receive]: COUPON_STATUS.receive,
  [COUPON_STATUS.use]: COUPON_STATUS.use,
  [COUPON_STATUS.achieve]: COUPON_STATUS.achieve,
  [COUPON_STATUS.expired]: COUPON_STATUS.expired,
  [COUPON_STATUS.fail]: COUPON_STATUS.fail,
  [COUPON_STATUS.wait]: COUPON_STATUS.wait,
  [COUPON_STATUS.locked]: COUPON_STATUS.locked,
  [COUPON_STATUS.changeed]: COUPON_STATUS.changeed,
  [COUPON_STATUS.expansived]: COUPON_STATUS.expansived,
  [COUPON_STATUS.recovery]: COUPON_STATUS.recovery,
};

export const ORDER_STATUS = {
  init: 0, // 初始化
  padding: 1, // 交易中
  success: 2, // 成功
  fall: 3, // 失败
  closed: 4, // 订单已关闭
};

export const GROUP = {
  thirty: 30, // 30天
  ninety: 90, // 90天
};

export const RIGHTS_TYPE = {
  coupon: 1, // 优惠券
  active: 2, // 活动
  discount: 3, // 折扣
  ride: 4, // 骑行
};

export const RENEWAL_STATUS = {
  unavailable: 'UNAVAILABLE', // 续费功能关闭
  available: 'AVAILABLE', // 当前可续费
  signed: 'SIGNED', // 已开通自动续费
  handmax: 'HAND_MAX', // 手动续费到达阈值-续费不可用
};

export const RIDE_CARD_STATUS = {
  10: '已发放·待启用',
  20: '初始化',
  30: '已暂停',
  40: '已冻结',
  50: '已失效',
  60: '已失效',
  70: '已注销',
};
/** 两轮骑行卡 状态 */
export const RideCardStatusMap = {
  /** 已启用 */
  USING: 0,
  /** 待启动 */
  UN_USE: 10,
  /** 初始化 */
  INIT: 20,
  /** 已暂停 */
  PAUSE: 30,
  /** 已冻结 */
  FROZEN: 40,
  /** 已失效 */
  EXPIRED: 50,
  /** 已失效 */
  USE_UP: 60,
  /** 已注销 */
  CANCEL: 70,
};
/** 老版会员tab名称版本映射 */
export const VERISON_MAP = {
  ride: '随心骑',
  ride_ebike: '轻松骑',
  ride_trial: '随心骑',
  ladder: '畅享出行',
  ladder_hitch: '畅享出行',
  driver: '车服务',
  ride_app: '随心骑',
  ride_ebike_app: '轻松骑',
  ladder_app: '畅享出行',
  ladder_hitch_app: '畅享出行',
  normal: '普通',
  ladder_blend: '畅享出行',
  ride_ebike_fifteen: '轻松骑',
  ride_ebike_thirty: '轻松骑',
  ride_agg_ebike: '轻松骑',
  ladder_blend_two: '畅享出行',
  ride_universal: '随心骑',
  ride_steady_version: '随心骑',
  ride_radical_version: '随心骑',
  ladder_discount_95_rate: '畅享出行',
  ride_one_cent: '1分骑会员',
};

export const VERISON_CORNER_MARK_MAP = {
  ride_one_cent: 'https://m.hellobike.com/65c80c9a_891891293.png',
};

export const VERISON_SHOW_MAP = {
  ride: '随心骑',
  ride_ebike: '轻松骑',
  ride_trial: '随心骑',
  ladder: '畅享出行',
  ladder_hitch: '畅享出行',
  driver: '车服务',
  ride_app: '随心骑',
  ride_ebike_app: '轻松骑',
  ladder_app: '畅享出行',
  ladder_hitch_app: '畅享出行',
  normal: '超级',
  ride_universal: '随心骑',
  ride_steady_version: '随心骑',
  ride_radical_version: '随心骑',
  ladder_discount_95_rate: '畅享出行',
  ride_one_cent: '随心骑',
};

export const VERISON_WORD = {
  ride: '单车',
  ride_ebike: '助力车',
  ride_trial: '单车',
  ride_app: '单车',
  ride_ebike_app: '助力车',
  ladder: '打车',
  ladder_hitch: '打车',
  ladder_app: '打车',
};

export const VERISON_STATEMENT = {
  ride: '单车不限次骑行',
  ride_ebike: '助力车优惠骑行',
  ride_trial: '单车不限次骑行',
  ride_app: '单车不限次骑行',
  ride_ebike_app: '助力车优惠骑行',
  ladder: '打车越用越省',
  ladder_hitch: '打车越用越省',
  ladder_app: '打车越用越省',
  ladder_hitch_app: '打车越用越省',
  ladder_blend: '打车越用越省',
  ladder_blend_two: '打车越用越省',
  ladder_discount_95_rate: '打车越用越省',
  ride_ebike_fifteen: '助力车优惠骑行',
  ride_ebike_thirty: '助力车优惠骑行',
  ride_agg_ebike: '助力车优惠骑行',
  ride_one_cent: '骑行单单0.01元',
};

export const LOTTERY_PRIZE_STATUS = {
  drawing: 2, // 抽奖中
  signed: 4, // 已报名
  draw_access: 5, // 可抽奖
  draw_limited: 6, // 领券用券可抽奖
  signed_haveSubscribe: 7, // 服务端没有此状态，仅作埋点用，已报名且已设置订阅
};

// 膨胀券类型
export const EXPAND_TYPE = {
  normal_expand: 1, // 膨胀至x元
  free_expand: 2, // 膨胀至免单
};

// 抽奖比例icon
export const RATIO_ICON_MAP = {
  1: 'https://m.hellobike.com/resource/gallery/833/6hMMq7CY_x1.png',
  2: 'https://m.hellobike.com/resource/gallery/833/em0RNoxB_x2.png',
  3: 'https://m.hellobike.com/resource/gallery/833/VPNF-Kmp_x3.png',
};

// 抽奖活动标签
export const LOTTERY_PRIZE_TAG_MAP = {
  1: 'https://m.hellobike.com/resource/gallery/833/yyqJlKuz_Group%201707484580.png',
  2: 'https://m.hellobike.com/resource/gallery/833/43q_JV0p_Group%201707484568.png',
};

// 免单券业务类型
export const FREE_RIGHT_TYPE = {
  bike: 'bike', // 单车免单
  taxi: 'taxi', // 顺风车免单
  hitch: 'hitch_ride', // 租车免单
  lottery: 'draw_day', // 日日抽
};

// 免单版本权益模块 其他状态枚举
export const FREE_RIGHT_STATUS = {
  canReceive: 1, // 可领取
  used: 5, // 已使用
  unlock: 10, // 待解锁
  // 以下与显示状态无关
  remain_days: 2, // 剩余天数
  book_car: 3, // 去约车
  rent_car: 4, // 去租车
};

export const RIGHT_TYPE = {
  prop: 'prop', // 卡券
  img: 'img', // 非卡券
  taurus: 'taurus', // 奖励金
  deduction: 'deduction', // 会员折上95折特权
  external: 'external', // 外部权益类型
  freeRight: 'freeRight', // 免费权益
};
// 0：用户正常下单；10:手动续费下单； 30:连续包月下单
// JOINT_MEMBER_CIRCLE(110,"联名会员-连续包月"),
// JOINT_MEMBER_REBUY(120,"联名会员-手动续费"),
export const OrderOptType = {
  NORMAL: 0,
  MANUAL: 10,
  MONTHLY: 30,
  // 联名会员 连续包月
  JOINT_MEMBER_CIRCLE: 110,
  // 联名会员 手动续费
  JOINT_MEMBER_REBUY: 120,
};

// 抽奖记录tab
export const LOTTERY_RECORD_TAB_LIST = [
  {
    code: 1,
    name: '我获得的',
    spm: 'platform_wohuodetabdianji',
  },
  {
    code: 2,
    name: '参与记录',
    spm: 'platform_choujiangjilu',
  },
  {
    code: 3,
    name: '中奖公示',
    spm: 'platform_gongshizhankai',
  },
];

// 订单类型常量
export const ORDER_TYPE = {
  SINGLE_MONTH: 0, // 单月购买
  // MANUAL_RENEWAL: 10, // 手动续费下单??
  CONTINUOUS_MONTHLY: 30, // 连续包月
  UNION_SINGLE_MONTH: 100, // 联名会员 单月购买
  UNION_CONTINUOUS_MONTH: 110, // 联名会员 连续包月
  // 以下暂未用到，补充的枚举值
  CUSTOMER: 1, // 客服补单
  MEMBER_ZERO: 21, // 会员0元购
  MEMBER_REBUY: 20, // 手动续费下单
  BATCH_AGREEMENT: 40, // 批次代扣
  EXTERNAL_SALE: 50, // 外部渠道下单
  RIDE_TRIAL_ZERO: 60, // 单车随心骑-体验版-0元开通自动续费
  HOME_PAGE_RIDE_TRIAL_ZERO: 70, // 单车随心骑-体验版-业务线新客
  TWO_WHEELS_CARD_HOLDER_UPGRADE: 80, // 两轮持卡用户升级-单月
  TWO_WHEELS_CARD_HOLDER_UPGRADE_CIRCLE: 90, // 两轮持卡用户升级-包月
  JOINT_VIP_REBUY: 120, // 联名会员-手动续费
  RIDE_PAY_TYING_SALE: 200, // 两轮待支付页-搭售
  RIDE_THEME_CARD: 201, // 两轮主题卡
};

export const ANCHOR_MAP = {
  // 展示会员
  VIP: 'vip',
  // 单车卡
  RIDE: 'rideCard',
  // 一分骑会员
  ONECENTVIP: 'oneCentVip', // TO 我的页改版下掉
};

// 根据当前激活的tab，配置未激活tab的标题和子标题颜色
export const TAB_INACTIVE_COLORS = {
  rideCard: {
    title: '#fff',
    subTitle: '#b5d2ff',
  },
  vip: {
    title: '#000',
    subTitle: '#242729',
  },
  oneCentVip: {
    title: '#441D06',
    subTitle: '#8E6751',
  },
  freeRights: {
    title: '#fff',
    subTitle: '#b5d2ff',
  },
};

// 商品类别映射
export const GoodCategoryMap = {
  // 会员
  VIP: 'vip',
  // 单车卡
  RIDE: 'rideCard',
};


// 背景图片常量
export const BACKGROUND_IMAGES = {
  RIDE_FREE_RIGHTS: 'https://m.hellobike.com/resource/gallery/61/ua-t_Qa4_Slice%2016.png?x-oss-process=image/quality,q_80',
  RIDE_EBIKE: 'https://m.hellobike.com/resource/gallery/61/ZRKPnpLv_Slice%2018.png?x-oss-process=image/quality,q_80',
  RIDE_BIKE: 'https://m.hellobike.com/resource/gallery/61/ua-t_Qa4_Slice%2016.png?x-oss-process=image/quality,q_80',
  LADDER: 'https://m.hellobike.com/resource/gallery/61/n_juMaCu_Slice%2014.png?x-oss-process=image/quality,q_80',
  DEFAULT: 'https://m.hellobike.com/resource/gallery/61/L7sbd2gh_Slice%2017.png?x-oss-process=image/quality,q_80',
  NEW_H5_FREE_RIGHTS: 'https://m.hellobike.com/4d6fdd3f_miandanbeijing.png',
  NEW_H5_RIDE: 'https://m.hellobike.com/c220af1f_danche.png',
  NEW_H5_VIP: 'https://m.hellobike.com/0083cfb5_huiyuanbeijing.png',
};

// paddingTop 常量
export const PADDING_TOP = {
  EASY_BIKE_APP: '0.98rem',
  NOT_EASY_BIKE_APP: '0.62rem',
};

// 菜单配置
export const MENUS = [
  {
    name: '规则协议',
    icon:
      'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/bf77f80d-7f44-432a-97b2-a1b4a2027ae0.svg',
  },
  {
    name: '购买记录',
    icon:
      'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/5cdbe2d7-c086-4394-8012-80beb4b09fa6.svg',
  },
  {
    name: '客服中心',
    icon:
      'https://m.hellobike.com/resource/helloyun/08345/5AuBPuFHil.svg',
  },
];

// Tab Logo 图片
export const TABLOGO_IMG = 'https://m.hellobike.com/e4188f75_corner_mark.png';

// 骑行卡模块组件映射
export const RIDE_CARD_COMPONENT_MAP = {
  page_my_card_module: 'myRideCard', // 我的卡模块
  page_vip_recommend_coupon_visualization_module: 'rideMmberBlockC',
  page_sub_tying_card_module: 'rideCardList',
  page_main_tying_card_coupon_visualization_module: 'rideCardList',
};

// 业务类型映射
export const BUSINESS_TYPE_MAP = {
  bike: 1, // 单车
  ebike: 2, // 助力车
};
